export default __webpack_public_path__ + "static/media/user-students.c12dd57d.svg";